import { render, staticRenderFns } from "./SingleModelLayout.vue?vue&type=template&id=7834568d&"
import script from "./SingleModelLayout.vue?vue&type=script&lang=js&"
export * from "./SingleModelLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports